import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 10 minutes 48 seconds = 648 seconds
  const [timeLeft, setTimeLeft] = useState(648);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 648); // Reset if it hits 0 for demo purposes, or stay at 0
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-[#DC2626] text-white z-50 py-3 px-4 shadow-md" data-id="element-155">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-156">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-157" />
        <span data-id="element-158">Esta oferta termina pronto:</span>
        <span className="bg-white text-[#DC2626] px-2 py-0.5 rounded font-mono text-lg" data-id="element-159">
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </span>
      </div>
    </div>;
}